<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ "hours.overview" | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="container">
    <div>
      <div class="stretch border-top">
        <div class="centered">
          <ion-icon
            style="margin-right: 5px"
            name="person-circle-outline"
          ></ion-icon>
          <b>{{ state.getUserDisplayNameAsync(workDay?.user) | async }}</b>
        </div>
        <div>{{ this.tools.formatDt(workDay?.workingDate) }}</div>
      </div>

      <div class="stretch border-bottom">
        <div class="centered">
          <ion-icon name="timer-outline" style="margin-right: 5px"></ion-icon>
          {{ "hours.workTime" | translate }}: {{ workDay?.durationInHours }}H
          {{ workDay?.durationInMins }}M
        </div>
      </div>

      @for (workEntry of this.workDay?.workEntries; track workEntry; let i =
      $index) {
      <div class="work-entry">
        <div class="stretch-only border-top">
          <div class="centered pointer" (click)="openReport(workEntry)">
            <ion-icon
              style="margin-right: 5px"
              name="construct-outline"
            ></ion-icon>
            {{ state.getConstructionSiteName(workEntry.constructionSite) }}
          </div>
          <div class="centered">
            @if(workEntry.approvedBy == null){
            <ion-chip color="warning" (click)="openReport(workEntry)">
              <ion-icon
                color="warning"
                name="checkmark-circle-outline"
              ></ion-icon>
              <ion-label color="dark">{{
                "status.pending" | translate
              }}</ion-label>
            </ion-chip>
            } @if(workEntry.approvedBy != null){
            <ion-chip color="success" (click)="openReport(workEntry)">
              <ion-icon
                color="success"
                name="checkmark-circle-outline"
              ></ion-icon>
              <ion-label color="dark">{{
                "status.confirmed" | translate
              }}</ion-label>
            </ion-chip>
            }
            <ion-icon
              name="ellipsis-vertical-outline"
              (click)="openContextMenu($event, workEntry)"
            ></ion-icon>
          </div>
        </div>
        <div class="border-middle">
          @for (entry of workEntry.timeEntries; track entry; let i = $index) {
          <div>
            {{ tools.formatTime(entry.start) }}
            -
            {{ tools.formatTime(entry.end) }}
          </div>
          }
        </div>
        <div class="stretch border-middle">
          <div class="centered">
            {{ "hours.workTime" | translate }}: {{ workEntry.durationInHours }}H
            {{ workEntry.durationInMins }}M
          </div>
        </div>
        @if (workEntry?.description) {
        <div class="stretch border-middle multiline">
          {{ workEntry.description }}
        </div>
        } @if(state.userHasMinType(3)){
        <div class="stretch border-middle">
          <div>Id:</div>
          <div>
            {{ workEntry.id }}
          </div>
        </div>
        } @if(workEntry.lastModifiedDateUtc == workEntry.createdUtc){
        <div class="stretch border-bottom">
          <div>Erstellt:</div>
          <div>
            {{ state.getUserDisplayNameAsync(workEntry.createdBy) | async }}
            ({{ this.tools.formatDt(workEntry.createdUtc) }},
            {{ this.tools.formatTime(workEntry.createdUtc, true) }})
          </div>
        </div>
        } @if(workEntry.lastModifiedDateUtc != workEntry.createdUtc){
        <div class="stretch border-bottom">
          <div>{{ "common.lastModified" | translate }}:</div>
          <div>
            {{ state.getUserDisplayNameAsync(workEntry.createdBy) | async }}
            ({{ this.tools.formatDt(workEntry.lastModifiedDateUtc) }},
            {{ this.tools.formatTime(workEntry.lastModifiedDateUtc, true) }})
          </div>
        </div>
        }
      </div>
      }
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="footer-buttons">
      <ion-button (click)="editWorkDay()">{{
        "common.edit" | translate
      }}</ion-button
      ><ion-button color="danger" (click)="deleteWorkDay()">{{
        "hours.deleteDay" | translate
      }}</ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
